module.exports = __webpack_public_path__ + "static/media/004.2694c8c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/004.jpg
// module id = 477
// module chunks = 0